import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_run_files_presigned_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { notifications } from '@mantine/notifications';
import { Run } from '@/types/runs.ts';
import { UrlResponse } from '@/types/common.ts';
import { downloadDatasetFile } from '@/layouts/DataViewer/Viewers/datasetFileFetch.ts';

export type RunFilesType = 'inputs' | 'outputs' | 'all';

type DownloadRunFilesZipParams = {
  filesType: RunFilesType;
};

const useDownloadRunFilesZip = (
  run: Run,
): UseMutationResult<UrlResponse, AxiosError | Error, DownloadRunFilesZipParams> => {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async (params: DownloadRunFilesZipParams) => {
      notifications.show({
        title: 'Generating .zip file to download',
        message: 'This may take a few minutes depending on the size.',
        color: 'blue',
      });

      const apiResponse = await apiClient.get(
        get_run_files_presigned_url(run.id, params.filesType),
      );

      const downloaded = await downloadDatasetFile(apiResponse.data.url, `${run.name}.zip`, {
        errorTitle: 'Unable to download run files',
      });
      if (!downloaded) {
        throw new Error('Run files download failed');
      }

      return apiResponse.data;
    },
  });
};

export default useDownloadRunFilesZip;
